var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLabel = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.273 0.600999C0.273 0.432 0.3575 0.3475 0.5265 0.3475H7.3515C7.5205 0.3475 7.605 0.432 7.605 0.600999V1.8295C7.605 2.00283 7.5205 2.0895 7.3515 2.0895H4.8555V9.74C4.8555 9.91333 4.771 10 4.602 10H3.2045C3.0355 10 2.951 9.91333 2.951 9.74V2.0895H0.5265C0.3575 2.0895 0.273 2.00283 0.273 1.8295V0.600999Z",
    fill: "#202840"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLabel);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Label.b59c4a31665faddfa0dbee0f4598228a.svg";